import { render, staticRenderFns } from "./CommunityRepairTree.vue?vue&type=template&id=486b10b3&scoped=true"
import script from "./CommunityRepairTree.vue?vue&type=script&lang=js"
export * from "./CommunityRepairTree.vue?vue&type=script&lang=js"
import style0 from "./CommunityRepairTree.vue?vue&type=style&index=0&id=486b10b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b10b3",
  null
  
)

export default component.exports